import React, { useState, useEffect } from "react";
import { jsPDF } from 'jspdf';
import CadeteFormEdit from "./CadeteFormEdit";
import * as XLSX from 'xlsx';
import Modal from "./Modal";
import regresaBienFechaYDia from "../tools/regresaBienFechayDia";
import regresaBienFecha from "../tools/regresaBienFecha";
import ObtieneDatosCookies from "../tools/obtieneDatosCookiesUsuario";
import axios from 'axios';
import socket from "../tools/socke";
import devolvemeLaEdad from "../tools/devolvemeLaEdad";
const ImprimoListas = ({ cadetesData, titulo }) => {
  const [margen, setMargen] = useState('10');
  const [editaCadete, setEditaCadete] = useState(false)
  const [cadeteSeleccionado, setCadeteSeleccionado] = useState("")
  const Usuario = ObtieneDatosCookies();
  const [tituloPlanilla, setTituloPlanilla] = useState("")
  useEffect(() => {
    if (cadetesData && cadetesData.length > 19) {
      setMargen(16)
    } else if (cadetesData && cadetesData.length > 29) {
      setMargen(18)
    } else if (cadetesData && cadetesData.length > 39) {
      setMargen(20)
    }


    if (titulo == "Division") {
      setTituloPlanilla(cadetesData[0])
    }
    const miroDatosCadete = (info) => {
      window.open('/CadeteEdit?dni=' + info.cadeteDni, '_blank');
    };

    return () => {

    };
  }, []);
//   console.log(cadetesData)
  const actualizaCadete = async (data) => {
    try {

//       console.log("cm")
      const dataCadete = data
      var operacion = "Actualiza Cadete"

      const Cadete = { "Cadete": dataCadete, "Usuario": { "userID": Usuario.identificacion, "cadeteDni": dataCadete.cadeteDni, "Operacion": operacion } }

      const response = await axios.post('https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/actualizoCadete/' + dataCadete.cadeteDni, Cadete);
      if (response) {
        socket.emit("reempadrone", "dataCadete.cadeteDni")

        setEditaCadete(false)

      }

    } catch (error) {
      console.error('Error en la petición', error);
    }



  };



  const miroDatosCadete = (info) => {
    window.open('/CadeteEdit?dni=' + info.cadeteDni, '_blank');

  };

  const formatFecha = (fecha) => {
    const date = new Date(fecha);
    return date.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };
  const handleDownloadPDF = () => {
//     console.log("a")
    const doc = new jsPDF();

    // Establecer el tamaño de fuente
    doc.setFontSize(10);

    // Título
    doc.text(titulo, 5, 10);

    // Posición inicial en Y
    let yPosition = 20;

    // Configurar límite de página
    const maxY = 280; // Altura máxima antes de un salto de página

    // Ordenar los cadetes alfabéticamente por el campo 'cadeteApellido'
    const sortedCadetes = cadetesData.sort((a, b) => a.cadeteApellido.trim().localeCompare(b.cadeteApellido.trim()));


    // Iterar sobre los datos de los cadetes
    sortedCadetes.forEach((cadete, index) => {
      // Si la posición Y excede el límite, agrega una nueva página
      if (yPosition >= maxY) {
        doc.addPage();
        yPosition = 10; // Reiniciar la posición Y después de un salto de página
      }

      // Eliminar espacios iniciales y finales de cada campo, asegurando que sean cadenas
      const cadeteNombre = String(cadete.cadeteNombre).trim();
      const cadeteApellido = String(cadete.cadeteApellido).trim();
      const cadeteDni = String(cadete.cadeteDni).trim(); // Convertir a string antes de usar trim
      const cadeteCondicion = String(cadete.cadeteCondicion).trim();
      const cadeteEmail = String(cadete.cadeteEmail).trim();
      const cadeteSede = String(cadete.cadeteSede).trim();
      const fechaNacimiento = String(cadete.fechaNacimiento).trim();

      // Truncar el nombre del cadete a 25 caracteres
      const truncatedCadeteNombre = cadeteNombre.length > 25 ? cadeteNombre.substring(0, 25) + '...' : cadeteNombre;

      // Numerar los cadetes
      doc.text(`${index + 1})`, 5, yPosition);

      // Agregar los datos del cadete
      doc.text(`${cadeteApellido}, ${truncatedCadeteNombre} ${cadeteDni}`, margen, yPosition);
      doc.text(`${cadeteDni}`, margen + 80, yPosition);
      doc.text(`${cadeteSede}`, margen + 110, yPosition);


      // Actualizar la posición Y para el siguiente cadete
      yPosition += 4; // Incrementar en 10 unidades por cadete
    });

    // Abrir el PDF en una nueva pestaña
    doc.output('dataurlnewwindow');
  };

  const handleDownloadExcel = () => {
    // Crear un objeto con los datos para el Excel

    let data = ""
    if (Usuario.destino == 21 || Usuario.destino == 45) {//Administracion 
      data = cadetesData.map((cadete, index) => ({
        '#': index + 1,
        'Nombre': `${cadete.cadeteApellido}, ${cadete.cadeteNombre}`,
        'Sede': cadete.cadeteSede,
        'DNI': cadete.cadeteDni,
        'CUIL': cadete.cadeteCuil,
        'Fecha nac': cadete.fechaNacimiento.replace(/-/g, ""),
        'Domicilio': cadete.cadeteDomicilio,
        'Domicilio Nro': cadete.domicilioNumero,
        'Localidad': cadete.cadeteCiudad,
        'Cod Postal': cadete.codigoPostal,
        "email": cadete.cadeteEmail,
        "celular": cadete.cadeteCelular,
        'Departamento': cadete.cadeteUR,
        'Promocion': cadete.Promocions && cadete.Promocions.length > 0 ? cadete.Promocions[0].nombre : '-',
         'Es Reincorporado': cadete.esReincorporado=="No" ? '-':cadete.esReincorporado,


      }))
    }
    else if (Usuario.destino == 9 || Usuario.destino == 16) {//Reclutamiento 
      data = cadetesData.map((cadete, index) => ({
        '#': index + 1,
        'Nombre': `${cadete.cadeteApellido}, ${cadete.cadeteNombre}`,
        'DNI': cadete.cadeteDni,
        'Fecha Nacimiento': regresaBienFecha(cadete.fechaNacimiento),
        'Padre': cadete.cadetePadre,
        'Madre': cadete.cadeteMadre,
        'Domicilio': cadete.cadeteDomicilio + " " + cadete.domicilioNumero,
        'Localidad': cadete.cadeteCiudad,
        'Departamento': cadete.cadeteUR,
        'Condicion': cadete.cadeteCondicion,
        "email": cadete.cadeteEmail,
        'Sede': cadete.cadeteSede,
        "celular": cadete.cadeteCelular,
          'Es Reincorporado': cadete.esReincorporado=="No" ? '-':cadete.esReincorporado,


      }));
    }
    else if (Usuario.destino == 2) { // Secretaria Escuela de Policia
      data = cadetesData.map((cadete, index) => ({
        ...cadete,                // 👈 mantiene TODOS los nombres originales
        index: index + 1,         // opcional
        edad: devolvemeLaEdad(cadete.fechaNacimiento),
        desdeFecha:
          cadete.CambioCondicions?.length > 0
            ? formatFecha(
              cadete.CambioCondicions
                .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))[0].createdAt
            )
            : '-',
        promocion:
          cadete.Promocions?.length > 0
            ? cadete.Promocions[0].nombre
            : null
      }));



    } else {//el resto


      data = cadetesData.map((cadete, index) => ({
        '#': index + 1,
        'Nombre': `${cadete.cadeteApellido}, ${cadete.cadeteNombre}`,
        'DNI': cadete.cadeteDni,
        'cuil': cadete.cadeteCuil,
        'Genero': cadete.cadeteGenero,
        'Sede': cadete.cadeteSede,
        'Licencia': cadete.cadeteLicencia ? cadete.cadeteLicencia : "NO",
        'Condicion': cadete.cadeteCondicion,
        'Desde Fecha': cadete.CambioCondicions && cadete.CambioCondicions.length > 0
          ? formatFecha(
            cadete.CambioCondicions
              .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))[0].createdAt
          )
          : '-',
        'Licencia': cadete.cadeteLicencia,
        "Sede": cadete.cadeteSede,
        "Departamento": cadete.cadeteUR,
        "email": cadete.cadeteEmail,
        "celular": cadete.cadeteCelular,
        "Edad": devolvemeLaEdad(cadete.fechaNacimiento),
        'Promocion': cadete.Promocions && cadete.Promocions.length > 0 ? cadete.Promocions[0].nombre : '-',
          'Es Reincorporado': cadete.esReincorporado=="No" ? '-':cadete.esReincorporado,

      }));
    }



    // Crear un libro de trabajo de Excel

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Lista de Cadetes' + titulo);

    // Descargar el archivo de Excel
    XLSX.writeFile(wb, 'Lista_Cadetes' + titulo + ".xlsx");
  };
  const manejoEdito = (parametro) => {

    if (Usuario.destino == 7 || Usuario.destino == 6) {
      setCadeteSeleccionado(parametro)
      setEditaCadete(true)
    } else {

      miroDatosCadete(parametro)
    }

  }






  return (
    <div style={{ width: "100%" }}>
      {editaCadete && (
        <Modal isOpen={editaCadete} onClose={() => setEditaCadete(false)}>
          <div
            style={{
              padding: "20px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div style={{ overflowY: "auto", height: "500px" }}>

              <CadeteFormEdit cadete={cadeteSeleccionado}
                onClose={(f) => actualizaCadete(f)}
                onClick={() => setEditaCadete(false)} />
            </div>

          </div>
        </Modal>
      )}
      <table>
        <thead>
          <tr>
            <th>#</th>
            <th>Nombre</th>
            <th>DNI</th>
            <th>Condicion</th>
            <th>Genero</th>
            <th>Sede</th>
            <td>Reincorporado</td>

          </tr>
        </thead>
        <tbody style={{ textAlign: 'center', marginLeft: "10px", padding: "10px" }}>
          {cadetesData.map((cadete, index) => (

            <tr onClick={() => manejoEdito(cadete)} key={index}>
//               <td>{index + 1}{console.log(cadete)}</td>
              <td>{cadete.cadeteApellido} {cadete.cadeteNombre}</td>
              <td>{cadete.cadeteDni}</td>
              <td>{cadete.cadeteCondicion}</td>
              <td>{cadete.cadeteGenero}</td>
              <td>{cadete.cadeteSede}</td>
              <td>{cadete.cadeteEmail}</td>
              <td>{cadete.esReincorporado=="No"?"No":"Si"}</td>

            </tr>
          ))}

        </tbody>
      </table>
      <button className="btn btn-primary" onClick={handleDownloadPDF}>Generar PDF</button>
      <button className="btn btn-success" onClick={handleDownloadExcel}>Generar Excel</button>
    </div>
  );
};

export default ImprimoListas;

